import { useTranslation } from 'react-i18next'
import { WarningIcon } from '../icons'

export default function NotFoundCard() {
    const { t } = useTranslation()

    return (
        <div className="gap-[10px] w-full rounded border-[1px] border-[#DDE5EC] flex items-center justify-center py-2">
            <WarningIcon />
            <p>{t('appEnabled.data_not_found')}</p>
        </div>
    )
}
